import React, { useState } from "react";
import Form from "formsy-react";
import { FormattedMessage, useIntl } from "react-intl";
import SelectField from "../../components/bootstrap/select-field";
import { useHistory } from "react-router-dom";
import { getFormData, setFormData } from "../../components/manager/form";
import { useMutation, useQuery } from "@apollo/client";
import TextField from "../../components/bootstrap/input-alt";
import {
  createMobileVerificationMutation,
  resendVerificationMutation,
  validateMobileVerificationMutation,
} from "../../components/logic/mobile";
import Captcha from "../../components/bootstrap/captcha2";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalTitle,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import "../../style/custom/confirm-user-details.scss";

function MobileValidationForm(props) {
  const { show, handleClose } = props;

  const data = getFormData();
  const { mobileNumber } = data;

  const [error, setError] = useState(null);
  const [seconds, setSeconds] = useState(30);
  const [processing, setProcessing] = useState(false);
  const [valid, setValid] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");

  const history = useHistory();
  function handleValid() {
    setValid(true);
  }

  function handleInvalid() {
    setValid(false);
  }
  function handleTimer() {
    const itval = setInterval(() => {
      const s = seconds - 1;
      if (seconds < 1) {
        clearInterval(itval);
        setSeconds(0);
        setInterval(null);
      } else {
        setSeconds(s);
      }
    }, 1000);
  }
  const [resendMutation] = useMutation(resendVerificationMutation);
  const [validateMutation] = useMutation(validateMobileVerificationMutation);

  async function handleOnSubmit(values) {
    setProcessing(true);
    setFormData(values);
    const data = getFormData();
    const { mobileNumber } = data;
    const response = await validateMutation({
      variables: { mobileNumber, code: data.verification },
    });
    // console.log("response", { response, data });
    if (
      response?.data?.classMethods?.MobileVerification
        ?.validateMobileVerification
    ) {
      history.push("/review");
    } else {
      setProcessing(false);
      setError("Invalid Verification Code");
    }
    // return refs.form.updateInputsWithError({
    //   verification: "Invalid verification code",
    // });
  }

  async function handleOnInvalidSubmit() {
    if (seconds === 0) {
      await setProcessing(true);
      const data = getFormData();
      const { mobileCountry, mobileNumber } = data;
      const response = await resendMutation({
        variables: { mobileCountry, mobileNumber },
      });
      if (response.data.resendVerification) {
        setProcessing(false);
        setSeconds(30);
        return handleTimer();
      }
    }
    return undefined;
  }

  console.log(mobileNumber);
  const { formatMessage } = useIntl();
  return (
    <Modal className="user-confirmation-modal" show={show}>
      <Form
        className="confirmation-container"
        onValidSubmit={handleOnSubmit}
        onInvalidSubmit={handleOnInvalidSubmit}
        noValidate
        onValid={handleValid}
        onInvalid={handleInvalid}
      >
        <ModalTitle />
        <ModalBody>
          <Container fluid className="no-gutters">
            <p className="verification-title">{"Confirm your mobile number"}</p>

            {error ? (
              <div className="alert alert-danger">{error}</div>
            ) : (
              <div className="alert alert-info">
                {
                  "We have sent a 6-digit verification code to your phone, please enter the code below."
                }
              </div>
            )}
            <div>
              <label>{"Enter Mobile Verification Code"}</label>
              <TextField
                className="vw-confirmation-field"
                // onChange={handleOnTextChange}
                required
                placeholder={formatMessage({
                  id: "placeholders.mobileNumberVerification",
                })}
                validations={{
                  maxLength: 15,
                  isExisty: true,
                }}
                pattern="[0-9]*"
                inputMode="numeric"
                autoComplete="off"
                validationErrors={{
                  isExisty: (
                    <FormattedMessage id="validation.errors.required.mobileNumberVerification" />
                  ),
                  maxLength: (
                    <FormattedMessage id="validation.errors.maxLength50" />
                  ),
                }}
                name="verification"
                // disabled={processing}
                // defaultValue={data.verification}
              />
            </div>
          </Container>
        </ModalBody>
        <ModalFooter>
          <div className="verification-actions">
            <button className="vw-cancel-verification" onClick={handleClose}>
              {"Cancel"}
            </button>

            <input
              type="submit"
              className="confirm-proceed"
              value={formatMessage({
                id:
                  seconds === 0 && (verificationCode || "").length === 0
                    ? "register.userDetails.buttonResend"
                    : "register.userDetails.buttonConfirm",
              })}
              disabled={(!valid && seconds > 0) || processing}
            />
          </div>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

const UserFormPanel = (props) => {
  const { formatMessage } = useIntl();
  const [captchaKey, setCaptchaKey] = useState(new Date().getTime());
  const data = getFormData();
  const { processing } = props;
  const { firstName, lastName, homeAddress, email, mobileNumber } = data;
  const defaultCountry = homeAddress?.countryId
    ? homeAddress?.countryId
    : (props.countries || []).reduce((prev, value) => {
        return value && value.name === "Australia" ? value.id : prev;
      }, {});

  return (
    <div className="user-detail-panel-container">
      <MobileValidationForm
        show={props.showMobileVerificationForm}
        handleClose={props.handleCloseMobileVerificationForm}
      />
      <Form
        className="user-detail-section"
        onValidSubmit={props.handleOnSubmit}
      >
        <Row>
          <Col xs={12}>
            <div className="section-title">
              <FormattedMessage id="register.userDetails.name.start" />
            </div>
          </Col>
        </Row>
        <div className="user-form-container">
          <Container>
            <Row className="user-name-details">
              <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                <label>{"First Name"}</label>
                <TextField
                  name="firstName"
                  className="vw-form-field "
                  required
                  placeholder={formatMessage({ id: "placeholders.firstName" })}
                  validations={{
                    maxLength: 50,
                    isExisty: true,
                    isValidName: ({ firstName }) => {
                      const regex = new RegExp("^[a-zA-Z ]*$", "g");
                      return regex.test(firstName);
                    },
                  }}
                  validationErrors={{
                    isExisty: (
                      <FormattedMessage id="validation.errors.required.firstName" />
                    ),
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength50" />
                    ),
                    isValidName: (
                      <FormattedMessage id="validation.errors.isAlpha" />
                    ),
                  }}
                  defaultValue={firstName}
                />
              </Col>
              <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                <label>{"Last Name"}</label>
                <TextField
                  name="lastName"
                  className="vw-form-field "
                  placeholder={formatMessage({ id: "placeholders.lastName" })}
                  defaultValue={lastName}
                  required
                  validations={{
                    maxLength: 50,
                    isExisty: true,
                    isValidName: ({ lastName }) => {
                      if (lastName !== undefined) {
                        if (lastName.trim().length) {
                          const regex = new RegExp("^[a-zA-Z']*$", "g");
                          return regex.test(lastName.trim());
                        }
                      }

                      return false;
                    },
                  }}
                  validationErrors={{
                    isExisty: (
                      <FormattedMessage id="validation.errors.required.lastName" />
                    ),
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength50" />
                    ),
                    isValidName: (
                      <FormattedMessage id="validation.errors.isAlpha" />
                    ),
                  }}
                />
              </Col>
            </Row>

            <Row className="user-contact-details">
              <Col xl={6} lg={6} md={6} xs={12} className="vw-email">
                <label>{"Email"}</label>
                <TextField
                  className="vw-form-field  email-input"
                  autoComplete="off"
                  required
                  placeholder={formatMessage({
                    id: "placeholders.email",
                  })}
                  validations="isEmail"
                  validationError="This is not a valid email"
                  name="email"
                  defaultValue={email}
                  onPressEnter={(e) => {
                    // e.preventDefault()
                    // captcha.focus();
                    // return false;
                  }}
                />
              </Col>

              <Col xl={6} lg={6} md={6} xs={12} className="vw-mobile">
                <label>{"Mobile Number"}</label>
                <TextField
                  className="vw-form-field  phone-input"
                  pattern="[0-9]*"
                  inputMode="numeric"
                  inputClass="form-control ml-0"
                  autoComplete="off"
                  required
                  placeholder={formatMessage({
                    id: "placeholders.mobileNumber",
                  })}
                  validations={{
                    maxLength: 50,
                    isNumeric: true,
                    isExisty: true,
                  }}
                  validationErrors={{
                    isExisty: (
                      <FormattedMessage id="validation.errors.required.mobileNumber" />
                    ),
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength50" />
                    ),
                    isNumeric: (
                      <FormattedMessage id="validation.errors.isNumeric" />
                    ),
                  }}
                  name="mobileNumber"
                  defaultValue={mobileNumber}
                  onPressEnter={(e) => {
                    // e.preventDefault()
                    // captcha.focus();
                    // return false;
                  }}
                />
              </Col>
            </Row>
            <p className="subsection-title">{"Home Address"}</p>
            <hr/>
            <Row className="user-apartment-details">
              <Col xl={2} lg={2} md={6} sm={12} xs={12}>
                <label>{"Unit No."}</label>
                <TextField
                  label="Unit No."
                  name="homeAddress.unitNo"
                  className="vw-form-field "
                  //required
                  placeholder={formatMessage({id: "placeholders.address.unit"})}
                  validations={{
                    maxLength: 50,
                    isExisty: true,
                  }}
                  validationErrors={{
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength50" />
                    ),
                  }}
                  defaultValue={homeAddress?.unitNo || ""}
                  readOnly
                />
              </Col>

              <Col xl={2} lg={2} md={6} sm={12} xs={12}>
                <label>{"Street No"}</label>
                <TextField
                  name="homeAddress.streetNo"
                  className="vw-form-field "
                  value={homeAddress?.streetNo}
                  required
                  placeholder={formatMessage({id: "placeholders.streetNo"})}
                  validations={{
                    maxLength: 50,
                    isExisty: true,
                  }}
                  validationErrors={{
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength50" />
                    ),
                  }}
                  readOnly
                  defaultValue={homeAddress?.streetNo}
                />
              </Col>

              <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                <label>{"Address"}</label>
                <TextField
                  name="homeAddress.address"
                  className="vw-form-field "
                  defaultValue={homeAddress?.address}
                  required
                  placeholder={formatMessage({id: "placeholders.streetAddress"})}
                  validations={{
                    maxLength: 50,
                    isExisty: true,
                  }}
                  validationErrors={{
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength50" />
                    ),
                  }}
                  readOnly
                />
              </Col>
            </Row>

            <Row className="user-building-details">
              <Col xl={3} lg={3} md={6} className="city">
                <label>{"City"}</label>
                <TextField
                  name="homeAddress.suburb"
                  className="vw-form-field"
                  placeholder={formatMessage({id: "placeholders.suburb"})}
                  defaultValue={homeAddress?.suburb}
                  required
                  validations={{
                    maxLength: 50,
                    isExisty: true,
                  }}
                  validationErrors={{
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength50" />
                    ),
                  }}
                  readOnly
                />
              </Col>

              <Col xl={3} lg={3} md={6} className="state">
                <label>{"State"}</label>
                <TextField
                  name="homeAddress.state"
                  className="vw-form-field "
                  defaultValue={homeAddress?.state}
                  placeholder={formatMessage({id: "placeholders.state"})}
                  required
                  validations={{
                    maxLength: 50,
                  }}
                  validationErrors={{
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength50" />
                    ),
                  }}
                  readOnly
                />
              </Col>

              <Col xl={3} lg={3} md={6} className="country">
                <label>{"Country"}</label>
                <SelectField
                  readOnly
                  disabled
                  required
                  defaultValue={homeAddress?.countryId || defaultCountry}
                  name="homeAddress.countryId"
                  className="vw-form-field"
                >
                  {(props.countries || []).map((country) => {
                    return (
                      <option
                        value={(country || {}).id}
                        key={(country || {}).id}
                      >
                        {(country || {}).name}
                      </option>
                    );
                  })}
                </SelectField>
              </Col>

              <Col xl={3} lg={3} md={6} className="postal">
                <label>{"Postal Code"}</label>
                <TextField
                  name="homeAddress.postCode"
                  className="vw-form-field"
                  placeholder={formatMessage({id: "placeholders.postCode"})}
                  defaultValue={homeAddress?.postCode}
                  required
                  validations={{
                    maxLength: 50,
                  }}
                  validationErrors={{
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength50" />
                    ),
                  }}
                  readOnly
                />
              </Col>
            </Row>

            <p className="subsection-title">{"Payment Details"}</p>
            <hr />

            <Row className="user-payment-details">
              <Col
                xl={6}
                lg={6}
                md={12}
                sm={12}
                xs={12}
                className="card-holder-name"
              >
                <label>{"Card Holder Name"}</label>
                <TextField
                  name="cardName"
                  className="vw-form-field"
                  required
                  autoComplete="off"
                  placeholder={formatMessage({ id: "placeholders.cardName" })}
                  validations={{
                    maxLength: 50,
                    isExisty: true,
                    matchRegexp: /^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/,
                  }}
                  validationErrors={{
                    isExisty: (
                      <FormattedMessage id="validation.errors.required.cardName" />
                    ),
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength50" />
                    ),
                    matchRegexp: (
                      <FormattedMessage id="validation.errors.required.cardName" />
                    ),
                  }}
                />
              </Col>

              <Col
                xl={6}
                lg={6}
                md={12}
                sm={12}
                xs={12}
                className="card-number"
              >
                <label>{"Card Number"}</label>
                <TextField
                  name="cardNumber"
                  className="vw-form-field"
                  required
                  placeholder={formatMessage({ id: "placeholders.cardNumber" })}
                  pattern="[0-9]*"
                  inputMode="numeric"
                  autoComplete="off"
                  validations={{
                    maxLength: 16,
                    minLength: 16,
                    isNumeric: true,
                    isExisty: true,
                  }}
                  validationErrors={{
                    isExisty: (
                      <FormattedMessage id="validation.errors.required.cardNumber" />
                    ),
                    minLength: (
                      <FormattedMessage id="validation.errors.minLength16" />
                    ),
                    maxLength: (
                      <FormattedMessage id="validation.errors.minLength16" />
                    ),
                    isNumeric: (
                      <FormattedMessage id="validation.errors.isNumeric" />
                    ),
                  }}
                />
              </Col>
            </Row>

            <Row className="user-account-details">
              <Col lg={3} md={5} sm={12} xs={12}>
                <label>{"Expiry Month"}</label>
                <TextField
                  name="cardExpiryMonth"
                  className="vw-form-field"
                  mask={[/\d/, /\d/]}
                  required
                  placeholder={"EXP (MM)"}
                  pattern="[0-9]*"
                  inputMode="numeric"
                  autoComplete="off"
                  validations={{
                    minLength: 2,
                    maxLength: 2,
                    isNumeric: true,
                    isExisty: true,
                  }}
                  validationErrors={{
                    isExisty: (
                      <FormattedMessage id="validation.errors.required.cardExpiryMonth" />
                    ),
                    minLength: (
                      <FormattedMessage id="validation.errors.minLength2" />
                    ),
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength2" />
                    ),
                    isNumeric: (
                      <FormattedMessage id="validation.errors.isNumeric" />
                    ),
                  }}
                />
              </Col>

              <Col lg={3} md={5} sm={12} xs={12}>
                <label>{"Expiry Year"}</label>
                <TextField
                  name="cardExpiryYear"
                  className="vw-form-field"
                  mask={[/\d/, /\d/]}
                  required
                  placeholder={"EXP (YY)"}
                  pattern="[0-9]*"
                  inputMode="numeric"
                  autoComplete="off"
                  validations={{
                    minLength: 2,
                    maxLength: 2,
                    isNumeric: true,
                    isExisty: true,
                  }}
                  validationErrors={{
                    isExisty: (
                      <FormattedMessage id="validation.errors.required.cardExpiryYear" />
                    ),
                    minLength: (
                      <FormattedMessage id="validation.errors.minLength2" />
                    ),
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength2" />
                    ),
                    isNumeric: (
                      <FormattedMessage id="validation.errors.isNumeric" />
                    ),
                  }}
                />
              </Col>

              <Col xl={6} lg={5} md={12} sm={12} xs={12} className="cvc">
                <label>{"CVC"}</label>
                <TextField
                  name="cardCCV"
                  className="vw-form-field"
                  required
                  autoComplete="off"
                  pattern="[0-9]*"
                  inputMode="numeric"
                  placeholder={"CVC"}
                  validations={{
                    maxLength: 3,
                    isNumeric: true,
                    isExisty: true,
                  }}
                  validationErrors={{
                    isExisty: (
                      <FormattedMessage id="validation.errors.required.cardCCV" />
                    ),
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength3" />
                    ),
                    isNumeric: (
                      <FormattedMessage id="validation.errors.isNumeric" />
                    ),
                  }}
                />
              </Col>
            </Row>

            <div className="user-validation-actions">
              <Captcha
                key={captchaKey}
                inputClassName="vw-form-field"
                rowClass="vw-form-field"
              />

              {processing ? (
                <div className="rotating-loader-small" />
              ) : (
                <input
                  className="confirm-proceed"
                  type="submit"
                  disabled={props.processing}
                  value={formatMessage({
                    id: "register.userDetails.buttonConfirm",
                  })}
                />
              )}
            </div>
          </Container>
        </div>
      </Form>
    </div>
  );
};

export default UserFormPanel;
